<script setup lang="ts">
    import { PropType, ref } from 'vue';
    import {
        ContentExtractionSpecificationInProgress,
        addFilter,
        removeFilter
    } from './contentSpecification';

    const selectedColumn = ref<string | null>();
    const selectedOperator = ref<string | null>();
    const columnValue = ref<string | null>();

    const props = defineProps({
        extraction: {
            type: Object as PropType<ContentExtractionSpecificationInProgress>,
            required: true
        }
    });

    /*
        In this component we will allow mutation of prop state through the functions
        addFilter() and removeFilter(). This is ok because of the thight coupling
        of compnentents, and because we want the parent to be ignorant about the manipulation
        of wizard-specific data.
    */

    const operators = [
        { display: 'equal', value: '=' },
        { display: 'not equal', value: '!=' },
        { display: 'like', value: 'like' }
    ];

    function onAddFilter(): void {
        if (selectedColumn.value && selectedOperator.value && columnValue.value) {
            addFilter(
                props.extraction,
                selectedColumn.value,
                selectedOperator.value,
                columnValue.value);
            selectedColumn.value = null;
            selectedOperator.value = null;
            columnValue.value = null;
        }
    }

    function onRemoveFilterByIndex(index: number): void {
        removeFilter(props.extraction, index);
    }

</script>

<template>
    <b-field
        horizontal
        position="is-left"
        label="Apply filters">
        <b-field
            grouped
            group-multiline>
            <b-tag
                v-for="(query, index) in props.extraction.queries"
                :key="index"
                type="is-primary"
                size="is-medium"
                closable
                @close="onRemoveFilterByIndex(index)">
                {{ query[0] }} {{ query[1] }} {{ query[2] }}
            </b-tag>
        </b-field>
    </b-field>

    <b-field horizontal>
        <b-field>
            <b-select
                v-model="selectedColumn"
                placeholder="Select attribute">
                <option
                    v-for="option in props.extraction?.columns"
                    :key="option.name">
                    {{ option.name }}
                </option>
            </b-select>
            <b-select
                v-model="selectedOperator"
                placeholder="Select operator">
                <option
                    v-for="op in operators"
                    :key="op.value"
                    :value="op.value">
                    {{ op.display }}
                </option>
            </b-select>
            <b-input
                v-model="columnValue"
                placeholder="Specify value" />
            <p class="control">
                <b-button
                    icon-left="plus-circle-outline"
                    type="is-primary"
                    @click="onAddFilter">
                    Add
                </b-button>
            </p>
        </b-field>
    </b-field>
</template>
